import { render } from "./EventDetails.vue?vue&type=template&id=0fa6d3a0&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0fa6d3a0"

export default script